import { FC } from "react";
import { Button, Modal } from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { InfoCircle } from "untitledui-js-base";

type Props = {
  opened: boolean;
  onClose: () => void;
  onDelete: () => void;
};

export const DeleteUnitModal: FC<Props> = ({ opened, onClose, onDelete }) => {
  const { unit } = useUnitsPropertiesDictionary();
  return (
    <Modal
      zIndex={52}
      opened={opened}
      onClose={onClose}
      panelClassName="w-[366px] items-center flex flex-col p-6"
    >
      <div className="mb-4 rounded-full bg-danger-50 p-4">
        <InfoCircle className="h-8 w-8 stroke-danger-500" />
      </div>
      <p className="mb-8 text-center text-xl font-bold">
        Are you sure you want to delete this {unit}?
      </p>
      <div className="flex w-full gap-2.5">
        <div className="flex-grow">
          <Button className="w-full" onClick={onClose}>
            Cancel
          </Button>
        </div>
        <div className="flex-grow">
          <Button
            className="w-full bg-danger-600 text-content-1000-inverted hover:bg-danger-700"
            onClick={onDelete}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
